import * as React from 'react'
import { ResultStore } from '../../../store/ResultStore'
import { UserStore } from '../../../store/UserStore'
import ResultsStatisticsCard, { IResultsStatisticsCardProps } from './ResultsStatisticsCard'
interface IResultsStatisticsState {
  deployed: boolean
}

class ResultsStatistics extends React.Component<{}, IResultsStatisticsState> {
  public constructor(props) {
    super(props)
    this.state = {
      deployed: false,
    }
  }

  public render() {
    const cardData: IResultsStatisticsCardProps = {
      title: 'ma situation',
      isInMark: ResultStore.isInConsumptionMarks,
      text: this.getSentence('overall'),
      guysIconCount: Math.ceil(ResultStore.overallConsumptionStat / 10),
    }

    return (
      <div className="ResultsStatistics">
        <div className="ResultsStatistics__cards">
          <ResultsStatisticsCard
            title={cardData.title}
            isInMark={cardData.isInMark}
            guysIconCount={cardData.guysIconCount}
            text={cardData.text}
            dynamic={true}
          />
          <ResultsStatisticsCard title="Les repères" dynamic={false} />
        </div>
        <p className="ResultsStatistics__mention">
          Données issues du Baromètre de Santé publique France de 2017, enquête représentative de la
          population en France.
        </p>
      </div>
    )
  }

  private getSentence(rep: string): string[] {
    const gender = UserStore.gender === 'F' ? 'femmes' : 'hommes'

    const stringList: string[] = []

    switch (rep) {
      case 'rep1':
        if (ResultStore.rep1 === 0) {
          stringList.push(
            `Comme ${Math.round(
              ResultStore.quantityPerDayStat
            )}% des ${gender} de votre âge, vous n'avez pas bu`
          )
          stringList.push(' plus de 2 verres')
          stringList.push(' par jour')
          return stringList
        }
        stringList.push(
          `Comme seulement ${Math.round(
            ResultStore.quantityPerDayStat
          )}% des ${gender} de votre âge, vous avez bu`
        )
        stringList.push(' plus de 2 verres')
        stringList.push(' dans une même journée')
        return stringList
      default:
        if (!ResultStore.isInConsumptionMarks) {
          stringList.push(
            `Comme seulement ${Math.round(
              ResultStore.overallConsumptionStat
            )}% des ${gender} de votre âge, `
          )
          stringList.push('vous dépassez les repères de consommation')

          return stringList
        }

        stringList.push(
          `Comme ${Math.round(ResultStore.overallConsumptionStat)}% des ${gender} de votre âge, `
        )
        stringList.push('vous êtes dans les repères de consommation')
        return stringList

        break
    }
  }
}

export default ResultsStatistics



// WEBPACK FOOTER //
// ./src/components/ResultsComponents/ResultsStatistics/ResultsStatistics.tsx